import React, { useState } from "react";
import { dignosisReportSubtitle, sessionReportSummaryReportTitle, sessionReportTitle } from "./SessionReport";
import { FormatArray, removeLastCommaAndWord } from "../../Utils/utils";
import { FormatArrayComponent, SubFormatArrayComponent } from "./SummaryArraySection";
import { TextField } from "@mui/material";


interface AssessmentRecommendationPropsType {
    dignosisPrincipalList: any;
    principalClinicalFindingsList: any;
    mentalSessionSummaryReportObject: any,
    dignosisSubthresholdList: any;
    isEdit: boolean,
    handleInputChange: any,
    dignosisValueChange: any
}

interface DiagnosisItem {
    disorder: string;
    type: string;
    code: string;
    severity: string;
}
const AssessmentRecommendation = ({ dignosisPrincipalList, principalClinicalFindingsList, mentalSessionSummaryReportObject, dignosisSubthresholdList, isEdit, handleInputChange, dignosisValueChange }: AssessmentRecommendationPropsType) => {

    const [principalClinicalFindingsData, setPrincipalClinicalFindingsData] = useState(principalClinicalFindingsList);

    const flattenDiagnosis = (data: any[]): DiagnosisItem[] => {
        const result: DiagnosisItem[] = [];
        data.forEach((obj) => {
            Object.keys(obj).forEach((key) => {
                if (obj[key]?.diagnosis?.length > 0) {
                    obj[key].diagnosis.forEach((diag: any) => {
                        result.push({
                            disorder: diag.disorder,
                            code: diag.code,
                            severity: diag.severity,
                            type: key
                        });
                    });
                }
            });
        });
        return result;
    };
    
    const diagnoDetailsSummaryData = flattenDiagnosis(principalClinicalFindingsList);



    const handleprincipalClinicalChange = (i: number, value: string, key: string, type: string) => {
        const updatedList = [...principalClinicalFindingsList];
        const index = updatedList.findIndex((el) => el[key]);
        if (index !== -1) {
            if (type === 'disorder') {
                updatedList[index][key].diagnosis[i].disorder =
                    value;
            } else if (type === 'code') {
                updatedList[index][key].diagnosis[i].code =
                    value;
            } else if (type === 'severity') {
                updatedList[index][key].diagnosis[i].severity =
                    value;
            }
            setPrincipalClinicalFindingsData(updatedList);
            dignosisValueChange(updatedList);

        }
    }

    const MDD = () => (
        <>
            <h3 style={{ marginLeft: "20px" }}>
                Major Depressive Disorder
            </h3>
            <ul>
                <li style={{ fontWeight: "bold" }}>
                    Symptoms:
                </li>
                <SubFormatArrayComponent
                    subIndex={"1_mdd_mood"}
                    keyName="Depressed Mood"
                    value={
                        mentalSessionSummaryReportObject.summary_mdd["1_mdd_mood"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                />
                <SubFormatArrayComponent
                    subIndex={"2_mdd_interest"}
                    keyName="Loss of Interest or Pleasure"
                    value={
                        mentalSessionSummaryReportObject.summary_mdd["2_mdd_interest"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                />
                <SubFormatArrayComponent
                    subIndex={"3_mdd_weight"}
                    keyName="Significant Weight Change or Appetite Alteration"
                    value={
                        mentalSessionSummaryReportObject.summary_mdd["3_mdd_weight"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                />
                <SubFormatArrayComponent
                    subIndex={"4_mdd_insomnia"}
                    keyName="Sleep Disturbances"
                    value={
                        mentalSessionSummaryReportObject.summary_mdd["4_mdd_insomnia"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                />

                <SubFormatArrayComponent
                    subIndex={"5_mdd_retardation"}
                    keyName="Psychomotor Agitation or Retardation"
                    value={
                        mentalSessionSummaryReportObject.summary_mdd["5_mdd_retardation"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                />

                <SubFormatArrayComponent
                    subIndex={"6_mdd_fatigue"}
                    keyName="Fatigue or Loss of Energy"
                    value={
                        mentalSessionSummaryReportObject.summary_mdd["6_mdd_fatigue"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                />

                <SubFormatArrayComponent
                    subIndex={"7_mdd_guilt"}
                    keyName="Feelings of Worthlessness or Excessive Guilt"
                    value={
                        mentalSessionSummaryReportObject.summary_mdd["7_mdd_guilt"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                />

                <SubFormatArrayComponent
                    subIndex={"8_mdd_concentration"}
                    keyName="Diminished Ability to Think or Concentrate"
                    value={
                        mentalSessionSummaryReportObject.summary_mdd["8_mdd_concentration"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                />

                <SubFormatArrayComponent
                    subIndex={"9_mdd_suicide"}
                    keyName="Recurrent Thoughts of Death or Suicide"
                    value={
                        mentalSessionSummaryReportObject.summary_mdd["9_mdd_suicide"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                />

                <FormatArrayComponent
                    subIndex={"10_mdd_symptom_count"}
                    keyName="Persistency of Symptoms"
                    value={
                        mentalSessionSummaryReportObject.summary_mdd["10_mdd_symptom_count"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                />

                <FormatArrayComponent
                    subIndex={"11_mdd_impairment"}
                    keyName="Functional Impairment"
                    value={
                        mentalSessionSummaryReportObject.summary_mdd["11_mdd_impairment"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                />

                <li style={{ fontWeight: "bold" }}>
                    Exclusions:
                </li>

                <FormatArrayComponent
                    subIndex={"12_mdd_exclusion_medical"}
                    keyName="Substance Use, Medication, or Medical Condition"
                    value={
                        mentalSessionSummaryReportObject.summary_mdd["12_mdd_exclusion_medical"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                />
                <SubFormatArrayComponent
                    subIndex={"13_mdd_exclusion_schizo"}
                    keyName="Schizophrenia Spectrum or Other Psychotic Disorders"
                    value={
                        mentalSessionSummaryReportObject.summary_mdd["13_mdd_exclusion_schizo"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                />
                <SubFormatArrayComponent
                    subIndex={"14_mdd_hypomanic"}
                    keyName="History of Hypomanic or Manic Episodes"
                    value={
                        mentalSessionSummaryReportObject.summary_mdd["14_mdd_hypomanic"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                />
            </ul>
        </>
    )

    const GAD = () => (
        <>
            <h3 style={{ marginLeft: "20px" }}>
                Generalized Anxiety Disorder
            </h3>
            <ul>
                <li style={{ fontWeight: "bold" }}>
                    Symptoms:
                </li>

                <SubFormatArrayComponent
                    subIndex={"1_gad_symptom"}
                    keyName="Excessive Anxiety or Worry"
                    value={
                        mentalSessionSummaryReportObject.summary_gad["1_gad_symptom"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_gad')}
                />
                <SubFormatArrayComponent
                    subIndex={"3_gad_control_of_worry"}
                    keyName="Difficulty in Controlling the Worry"
                    value={
                        mentalSessionSummaryReportObject.summary_gad["3_gad_control_of_worry"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_gad')}
                />
                <SubFormatArrayComponent
                    subIndex={"2_gad_physical_symptoms"}
                    keyName="Physical or Cognitive Symptoms"
                    value={
                        mentalSessionSummaryReportObject.summary_gad["2_gad_physical_symptoms"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_gad')}
                />
                <FormatArrayComponent
                    subIndex={"4_gad_impairment"}
                    keyName="Functional Impairment"
                    value={
                        mentalSessionSummaryReportObject.summary_gad["4_gad_impairment"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_gad')}
                />

                <li style={{ fontWeight: "bold" }}>
                    Exclusions:
                </li>
                <SubFormatArrayComponent
                    subIndex={"5a_gad_panic_exclusion"}
                    keyName="Panic Disorder"
                    value={
                        mentalSessionSummaryReportObject.summary_gad["5a_gad_panic_exclusion"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_gad')}
                />
                <SubFormatArrayComponent
                    subIndex={"5b_gad_social_anxiety_exclusion"}
                    keyName="Social Anxiety Disorder"
                    value={
                        mentalSessionSummaryReportObject.summary_gad["5b_gad_social_anxiety_exclusion"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_gad')}
                />
                <SubFormatArrayComponent
                    subIndex={"5c_gad_ocd_exclusion"}
                    keyName="Obsessive-Compulsive Disorder"
                    value={
                        mentalSessionSummaryReportObject.summary_gad["5c_gad_ocd_exclusion"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_gad')}
                />
                <SubFormatArrayComponent
                    subIndex={"5d_gad_medical_exclusion"}
                    keyName="Substance Use, Medication, or Medical Condition"
                    value={
                        mentalSessionSummaryReportObject.summary_gad["5d_gad_medical_exclusion"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_gad')}
                />
            </ul>
        </>
    )

    const SUD = () => (
        <>
            <h3 style={{ marginLeft: "20px" }}>
                Substance Use Disorder
            </h3>
            <ul>
                <FormatArrayComponent
                    subIndex={"1_dsm_control_usage"}
                    keyName="Impaired Control - Usage"
                    value={
                        mentalSessionSummaryReportObject.summary_sud["1_dsm_control_usage"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"2_dsm_control_desire"}
                    keyName="Impaired Control - Desire To Cut Down"
                    value={
                        mentalSessionSummaryReportObject.summary_sud["2_dsm_control_desire"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"3_dsm_control_commitment"}
                    keyName="Impaired Control - Time Commitment"
                    value={
                        mentalSessionSummaryReportObject.summary_sud["3_dsm_control_commitment"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"4_dsm_control_arduous"}
                    keyName="Impaired Control - Craving"
                    value={
                        mentalSessionSummaryReportObject.summary_sud["4_dsm_control_arduous"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"5_dsm_social_failure"}
                    keyName="Social Impairment - Failure"
                    value={
                        mentalSessionSummaryReportObject.summary_sud["5_dsm_social_failure"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"6_dsm_social_persistence"}
                    keyName="Social Impairment - Persistence"
                    value={
                        mentalSessionSummaryReportObject.summary_sud["6_dsm_social_persistence"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"7_dsm_social_decline"}
                    keyName="Social Impairment - Decline"
                    value={
                        mentalSessionSummaryReportObject.summary_sud["7_dsm_social_decline"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"8_dsm_risk_hazard"}
                    keyName="Risky Use - Hazard"
                    value={
                        mentalSessionSummaryReportObject.summary_sud["8_dsm_risk_hazard"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"9_dsm_risk_tenacity"}
                    keyName="Risky Use - Tenacity"
                    value={
                        mentalSessionSummaryReportObject.summary_sud["9_dsm_risk_tenacity"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"10_dsm_tolerance"}
                    keyName="Tolerance"
                    value={
                        mentalSessionSummaryReportObject.summary_sud["10_dsm_tolerance"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"10_a_dsm_tolerance_dosage_increase"}
                    keyName="Tolerance - Dosage Increase"
                    value={
                        mentalSessionSummaryReportObject.summary_sud["10_a_dsm_tolerance_dosage_increase"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"11_dsm_withdrawal"}
                    keyName="Withdrawal"
                    value={
                        mentalSessionSummaryReportObject.summary_sud["11_dsm_withdrawal"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"11_a_dsm_withdrawal_relief"}
                    keyName="Withdrawal - Relief"
                    value={
                        mentalSessionSummaryReportObject.summary_sud["11_a_dsm_withdrawal_relief"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
                <FormatArrayComponent
                    subIndex={"11_b_dsm_withdrawal_symptoms"}
                    keyName="Withdrawal - Symptoms"
                    value={
                        mentalSessionSummaryReportObject.summary_sud["11_b_dsm_withdrawal_symptoms"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                />
            </ul>
        </>
    )

    const INSOMNIA = () => (
        <>
            <h3 style={{ marginLeft: "20px" }}>Insomnia</h3>
            <ul>
                <FormatArrayComponent
                    subIndex={"1_insomnia_criterion_a"}
                    keyName="Sleep Difficulties"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["1_insomnia_criterion_a"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <SubFormatArrayComponent
                    subIndex={"1_insomnia_criterion_a"}
                    keyName="Initiating Sleep"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["1_a_insomnia_difficulty_initiating_sleep"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <SubFormatArrayComponent
                    subIndex={"1_b_insomnia_difficulty_maintaining_sleep"}
                    keyName="Maintaining Sleep"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["1_b_insomnia_difficulty_maintaining_sleep"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <SubFormatArrayComponent
                    subIndex={"1_c_insomnia_early_morning_awakening"}
                    keyName="Early Awakening"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["1_c_insomnia_early_morning_awakening"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <FormatArrayComponent
                    subIndex={"2_insomnia_distress_impairment"}
                    keyName="Distress/Impairment"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["2_insomnia_distress_impairment"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <FormatArrayComponent
                    subIndex={"3_insomnia_frequency"}
                    keyName="Frequency"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["3_insomnia_frequency"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <FormatArrayComponent
                    subIndex={"4_insomnia_duration"}
                    keyName="Duration"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["4_insomnia_duration"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <FormatArrayComponent
                    subIndex={"5_insomnia_opportunity"}
                    keyName="Adequate Opportunity"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["5_insomnia_opportunity"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <FormatArray
                    subIndex={"Exclusions"}
                    keyName="Exclusions"
                    value={" "}
                />
                <SubFormatArrayComponent
                    subIndex={"6_insomnia_exclusion_other_disorders"}
                    keyName="Other Sleep-Wake Disorder"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["6_insomnia_exclusion_other_disorders"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <SubFormatArrayComponent
                    subIndex={"7_insomnia_exclusion_substances"}
                    keyName="Substances"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["7_insomnia_exclusion_substances"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <SubFormatArrayComponent
                    subIndex={"8_insomnia_exclusion_medical_mental"}
                    keyName="Medical/Mental"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["8_insomnia_exclusion_medical_mental"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
            </ul>
        </>
    )

    const HYPERSOMNOLENCE = () => (
        <>
            <h3 style={{ marginLeft: "20px" }}>
                Hypersomnolence
            </h3>
            <ul>
                <FormatArrayComponent
                    subIndex={"9_hypersomnolence_criterion_a"}
                    keyName="Excessive Sleepiness"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["9_hypersomnolence_criterion_a"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <SubFormatArrayComponent
                    subIndex={"9_a_hypersomnolence_recurrent_sleep_periods"}
                    keyName="Recurrent Sleep Episodes"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["9_a_hypersomnolence_recurrent_sleep_periods"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <SubFormatArrayComponent
                    subIndex={"9_b_hypersomnolence_prolonged_sleep"}
                    keyName="Prolonged Sleep"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["9_b_hypersomnolence_prolonged_sleep"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <SubFormatArrayComponent
                    subIndex={"9_c_hypersomnolence_difficulty_awakening"}
                    keyName="Awakening Difficulty"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["9_c_hypersomnolence_difficulty_awakening"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <FormatArrayComponent
                    subIndex={"10_hypersomnolence_frequency"}
                    keyName="Frequency"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["10_hypersomnolence_frequency"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />

                <FormatArrayComponent
                    subIndex={"11_hypersomnolence_distress_impairment"}
                    keyName="Distress/Impairment"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["11_hypersomnolence_distress_impairment"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <FormatArray
                    subIndex={"Exclusions:"}
                    keyName="Exclusions"
                    value={" "}
                />
                <SubFormatArrayComponent
                    subIndex={"12_hypersomnolence_exclusion_other_disorders"}
                    keyName="Other Sleep-Awake Disorders"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["12_hypersomnolence_exclusion_other_disorders"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <SubFormatArrayComponent
                    subIndex={"13_hypersomnolence_exclusion_substances"}
                    keyName="Substances"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["13_hypersomnolence_exclusion_substances"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />

                <SubFormatArrayComponent
                    subIndex={"14_hypersomnolence_exclusion_medical_mental"}
                    keyName="Medical/Mental"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["14_hypersomnolence_exclusion_medical_mental"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <FormatArray
                    subIndex={"Severity"}
                    keyName="Severity"
                    value={""}
                />
                <SubFormatArrayComponent
                    subIndex={"15_a_hypersomnolence_severity_mild"}
                    keyName="Mild"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["15_a_hypersomnolence_severity_mild"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />

                <SubFormatArrayComponent
                    subIndex={"15_b_hypersomnolence_severity_moderate"}
                    keyName="Moderate"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["15_b_hypersomnolence_severity_moderate"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <SubFormatArrayComponent
                    subIndex={"15_c_hypersomnolence_severity_severe"}
                    keyName="Severe"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["15_c_hypersomnolence_severity_severe"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
            </ul>
        </>
    )

    const CRSWD = () => (
        <>
            <h3 style={{ marginLeft: "20px" }}>
                Circadian Rhythm Sleep-Wake Disorder{" "}
            </h3>
            <ul>

                <FormatArrayComponent
                    subIndex={"16_circadian_disruption"}
                    keyName="Circadian Disruption"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["16_circadian_disruption"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <FormatArrayComponent
                    subIndex={"17_circadian_sleepiness_insomnia"}
                    keyName="Sleepiness/Insomnia"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["17_circadian_sleepiness_insomnia"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />

                <FormatArrayComponent
                    subIndex={"18_circadian_distress_impairment"}
                    keyName="Distress/Impairment"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["18_circadian_distress_impairment"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <FormatArrayComponent
                    subIndex={"19_circadian_exclusion_other_disorders"}
                    keyName="Exclusion of other medical or mental conditions"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["19_circadian_exclusion_other_disorders"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <FormatArray
                    subIndex={"Subtype"}
                    keyName="Subtype"
                    value=""
                />
                <SubFormatArrayComponent
                    subIndex={"20_a_circadian_delayed_sleep_phase"}
                    keyName="Delayed Sleep Phase"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["20_a_circadian_delayed_sleep_phase"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <SubFormatArrayComponent
                    subIndex={"20_b_circadian_advanced_sleep_phase"}
                    keyName="Advanced Sleep Phase"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["20_b_circadian_advanced_sleep_phase"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />


                <SubFormatArrayComponent
                    subIndex={"20_c_circadian_irregular_sleep_wake"}
                    keyName="Irregular Sleep-Wake"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["20_c_circadian_irregular_sleep_wake"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />


                <SubFormatArrayComponent
                    subIndex={"20_d_circadian_non_24_hour"}
                    keyName="Non-24-Hour Sleep-Wake"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["20_d_circadian_non_24_hour"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <SubFormatArrayComponent
                    subIndex={"20_e_circadian_shift_work"}
                    keyName="Shift Work"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["20_e_circadian_shift_work"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
                <SubFormatArrayComponent
                    subIndex={"20_f_circadian_unspecified"}
                    keyName="Unspecified"
                    value={
                        mentalSessionSummaryReportObject.summary_sleep["20_f_circadian_unspecified"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sleep')}
                />
            </ul>
        </>
    )

    const PTSD = () => (
        <>
            <h3 style={{ marginLeft: "20px" }}>
                Post-Traumatic Stress Disorder (PTSD){" "}
            </h3>
            <ul>
                <FormatArrayComponent
                    subIndex={"1_ptsd_criterion_a"}
                    keyName="Exposure to Traumatic Event(s)"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["1_ptsd_criterion_a"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"1_a_ptsd_exposure_direct"}
                    keyName="Direct Exposure"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["1_a_ptsd_exposure_direct"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />

                <SubFormatArrayComponent
                    subIndex={"1_b_ptsd_exposure_witnessing"}
                    keyName="Witnessed Exposure"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["1_b_ptsd_exposure_witnessing"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"1_c_ptsd_exposure_learning"}
                    keyName="Learned Exposure"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["1_c_ptsd_exposure_learning"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"1_d_ptsd_exposure_aversive_details"}
                    keyName="Aversive Details Exposure"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["1_d_ptsd_exposure_aversive_details"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <FormatArrayComponent
                    subIndex={"2_ptsd_criterion_b"}
                    keyName="Intrusion Symptoms"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["2_ptsd_criterion_b"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"2_a_ptsd_intrusion_memories"}
                    keyName="Intrusive Memories"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["2_a_ptsd_intrusion_memories"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"2_b_ptsd_intrusion_dreams"}
                    keyName="Traumatic Dreams"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["2_b_ptsd_intrusion_dreams"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"2_c_ptsd_intrusion_flashbacks"}
                    keyName="Flashbacks"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["2_c_ptsd_intrusion_flashbacks"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"2_d_ptsd_intrusion_distress"}
                    keyName="Psychological Distress"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["2_c_ptsd_intrusion_flashbacks"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"2_e_ptsd_intrusion_reactions"}
                    keyName="Physiological Reactions"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["2_e_ptsd_intrusion_reactions"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <FormatArrayComponent
                    subIndex={"3_ptsd_criterion_c"}
                    keyName="Avoidance Symptoms"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["3_ptsd_criterion_c"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"3_a_ptsd_avoidance_thoughts"}
                    keyName="Thought Avoidance"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["3_a_ptsd_avoidance_thoughts"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"3_b_ptsd_avoidance_reminders"}
                    keyName="Reminder Avoidance"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["3_b_ptsd_avoidance_reminders"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <FormatArrayComponent
                    subIndex={"4_ptsd_criterion_d"}
                    keyName="Negative Cognitions and Mood"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["4_ptsd_criterion_d"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"4_a_ptsd_memory_loss"}
                    keyName="Amnesia"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["4_a_ptsd_memory_loss"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"4_b_ptsd_negative_beliefs"}
                    keyName="Negative Beliefs"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["4_b_ptsd_negative_beliefs"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"4_c_ptsd_self_blame"}
                    keyName="Self-Blame"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["4_c_ptsd_self_blame"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"4_d_ptsd_emotional_state"}
                    keyName="Negative Emotions"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["4_d_ptsd_emotional_state"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"4_e_ptsd_interest_loss"}
                    keyName="Interest Loss"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["4_e_ptsd_interest_loss"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"4_f_ptsd_detachment"}
                    keyName="Detachment"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["4_f_ptsd_detachment"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"4_g_ptsd_positive_emotions"}
                    keyName="Positive Emotion Deficit"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["4_g_ptsd_positive_emotions"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <FormatArrayComponent
                    subIndex={"5_ptsd_criterion_e"}
                    keyName="Alterations in Arousal and Reactivity"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["5_ptsd_criterion_e"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"5_a_ptsd_irritability"}
                    keyName="Irritability"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["5_a_ptsd_irritability"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"5_b_ptsd_reckless_behavior"}
                    keyName="Reckless Behavior"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["5_b_ptsd_reckless_behavior"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"5_c_ptsd_hypervigilance"}
                    keyName="Hypervigilance"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["5_c_ptsd_hypervigilance"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"5_d_ptsd_startle_response"}
                    keyName="Startle Response"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["5_d_ptsd_startle_response"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"5_e_ptsd_concentration"}
                    keyName="Concentration Issues"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["5_e_ptsd_concentration"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <SubFormatArrayComponent
                    subIndex={"5_f_ptsd_sleep_disturbance"}
                    keyName="Sleep Disturbance"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["5_f_ptsd_sleep_disturbance"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <FormatArrayComponent
                    subIndex={"6_ptsd_duration"}
                    keyName="Duration of Symptoms"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["6_ptsd_duration"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <FormatArrayComponent
                    subIndex={"7_ptsd_impairment"}
                    keyName="Duration of Symptoms"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["7_ptsd_impairment"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
                <FormatArrayComponent
                    subIndex={"8_ptsd_exclusion"}
                    keyName="Exclusion of Other Causes"
                    value={
                        mentalSessionSummaryReportObject.summary_ptsd["8_ptsd_exclusion"]
                    }
                    isEdited={isEdit}
                    handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                />
            </ul>
        </>
    )

    return (
        <>
            <span style={sessionReportTitle}>
                Assessment Recommendation Summary
            </span>
            <ul>
                <li key="Principal Clinical Findings">
                    <strong>Principal Clinical Findings:</strong>{" "}
                    {diagnoDetailsSummaryData.length > 0
                        ? diagnoDetailsSummaryData.map((item: { disorder: any; type: string; }, index: number) => (
                            <React.Fragment key={index}>
                                {item?.disorder?.length ? (
                                    <>
                                        {isEdit ? (
                                            <TextField
                                                key={index}
                                                variant="standard"
                                                fullWidth
                                                value={item.disorder}
                                                onChange={(e) =>
                                                    handleprincipalClinicalChange(
                                                        index,
                                                        e.target.value,
                                                        item.type,
                                                        "disorder",
                                                    )
                                                }
                                                style={{ display: "block" }}
                                            />
                                        ) : (
                                            <>
                                                <br />- {item.disorder}
                                            </>
                                        )}
                                    </>
                                ) : (
                                    " "
                                )}
                            </React.Fragment>
                        ))
                        : " "}

                </li>
                <li key="ICD-10 CM code">
                    <strong>ICD-10 CM code:</strong> <br></br>
                    {diagnoDetailsSummaryData.length > 0
                        ? diagnoDetailsSummaryData.map((item: { code: any; type: string; }, index: number) => (
                            <React.Fragment key={index}>
                                {item?.code?.length ? (
                                    <>
                                        {isEdit ? (
                                            <TextField
                                                key={index}
                                                variant="standard"
                                                fullWidth
                                                value={item.code}
                                                onChange={(e) =>
                                                    handleprincipalClinicalChange(
                                                        index,
                                                        e.target.value,
                                                        item.type,
                                                        "code",
                                                    )
                                                }
                                                style={{ display: "block" }}
                                            />
                                        ) : (
                                            <>
                                                <br />- {item.code}
                                            </>
                                        )}
                                    </>
                                ) : (
                                    " "
                                )}
                            </React.Fragment>
                        ))
                        : " "}

                </li>
            </ul>

            <span
                style={{
                    ...sessionReportTitle,
                    display: dignosisPrincipalList.length
                        ? "block"
                        : "none",
                }}
            >
                Assessment Recommendation Details
            </span>
            {/* MDD */}
            {dignosisPrincipalList.includes("MDD") && (
                <>
                    <h3 style={{ marginLeft: "20px" }}>
                        Major Depressive Disorder
                    </h3>
                    <ul>
                        <li key="Principal Clinical Findings">
                            <strong>Principal Clinical Findings:</strong>{" "}
                            {principalClinicalFindingsData.length &&
                                principalClinicalFindingsData.find(
                                    (item: { mdd: any }) => item.mdd
                                )?.mdd?.diagnosis ? (
                                principalClinicalFindingsData
                                    .find((item: { mdd: any }) => item.mdd)
                                    ?.mdd?.diagnosis.map(
                                        (
                                            item: { disorder: string; severity: string },
                                            index: number
                                        ) => (
                                            <React.Fragment key={index}>
                                                {index === 0 ? (
                                                    isEdit ? (
                                                        <TextField
                                                            key={index}
                                                            variant="standard"
                                                            fullWidth
                                                            value={item.disorder}
                                                            onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'mdd', 'disorder')}
                                                            style={{ display: "block" }}
                                                        />
                                                    ) : item?.disorder?.length ? (
                                                        removeLastCommaAndWord(item.disorder)
                                                    ) : (
                                                        "N-A"
                                                    )
                                                ) : (
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            paddingLeft: "2em",
                                                        }}
                                                    >
                                                        {isEdit ? (
                                                            <TextField
                                                                key={index}
                                                                variant="standard"
                                                                fullWidth
                                                                value={item.disorder}
                                                                onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'mdd', 'disorder')}
                                                                style={{ display: "block" }}
                                                            />
                                                        ) : item?.disorder?.length ? (
                                                            removeLastCommaAndWord(item.disorder)
                                                        ) : (
                                                            " "
                                                        )}
                                                    </span>
                                                )}
                                            </React.Fragment>
                                        )
                                    )
                            ) : (
                                " "
                            )}
                        </li>
                        <li key="ICD-10 CM code">
                            <strong>ICD-10 CM code:</strong>{" "}
                            {principalClinicalFindingsData.length &&
                                principalClinicalFindingsData.find(
                                    (item: { mdd: any }) => item.mdd
                                )?.mdd?.diagnosis ? (
                                principalClinicalFindingsData
                                    .find((item: { mdd: any }) => item.mdd)
                                    ?.mdd?.diagnosis.map(
                                        (
                                            item: { code: string; },
                                            index: number
                                        ) => (
                                            <React.Fragment key={index}>
                                                {index === 0 ? (
                                                    isEdit ? (
                                                        <TextField
                                                            key={index}
                                                            variant="standard"
                                                            fullWidth
                                                            value={item.code}
                                                            onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'mdd', 'code')}
                                                            style={{ display: "block" }}
                                                        />
                                                    ) : item?.code?.length ? (
                                                        removeLastCommaAndWord(item.code)
                                                    ) : (
                                                        "N-A"
                                                    )
                                                ) : (
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            paddingLeft: "2em",
                                                        }}
                                                    >
                                                        {isEdit ? (
                                                            <TextField
                                                                key={index}
                                                                variant="standard"
                                                                fullWidth
                                                                value={item.code}
                                                                onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'mdd', 'code')}
                                                                style={{ display: "block" }}
                                                            />
                                                        ) : item?.code?.length ? (
                                                            removeLastCommaAndWord(item.code)
                                                        ) : (
                                                            " "
                                                        )}
                                                    </span>
                                                )}
                                            </React.Fragment>
                                        )
                                    )
                            ) : (
                                " "
                            )}
                        </li>

                        <FormatArrayComponent
                            subIndex={"15_mdd_episode_type"}
                            keyName="Episode Type"
                            value={
                                mentalSessionSummaryReportObject.summary_mdd["15_mdd_episode_type"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                        />
                        <li key="serverity">
                            <strong>serverity:</strong> <br></br>
                            {principalClinicalFindingsData.length &&
                                principalClinicalFindingsData.find(
                                    (item: { mdd: any }) => item.mdd
                                )?.mdd?.diagnosis ? (
                                principalClinicalFindingsData
                                    .find((item: { mdd: any }) => item.mdd)
                                    ?.mdd?.diagnosis.map(
                                        (
                                            item: { severity: string; },
                                            index: number
                                        ) => (
                                            <React.Fragment key={index}>
                                                {index === 0 ? (
                                                    isEdit ? (
                                                        <TextField
                                                            key={index}
                                                            variant="standard"
                                                            fullWidth
                                                            value={item.severity}
                                                            onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'mdd', 'severity')}
                                                            style={{ display: "block" }}
                                                        />
                                                    ) : item?.severity?.length ? (
                                                        removeLastCommaAndWord(item.severity)
                                                    ) : (
                                                        "N-A"
                                                    )
                                                ) : (
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            paddingLeft: "2em",
                                                        }}
                                                    >
                                                        {isEdit ? (
                                                            <TextField
                                                                key={index}
                                                                variant="standard"
                                                                fullWidth
                                                                value={item.severity}
                                                                onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'mdd', 'severity')}
                                                                style={{ display: "block" }}
                                                            />
                                                        ) : item?.severity?.length ? (
                                                            removeLastCommaAndWord(item.severity)
                                                        ) : (
                                                            " "
                                                        )}
                                                    </span>
                                                )}
                                            </React.Fragment>
                                        )
                                    )
                            ) : (
                                " "
                            )}

                        </li>
                        <FormatArrayComponent
                            subIndex={"17a_mdd_remission_partial"}
                            keyName="Remission Status Partial"
                            value={
                                mentalSessionSummaryReportObject.summary_mdd["17a_mdd_remission_partial"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                        />
                        <FormatArrayComponent
                            subIndex={"17b_mdd_remission_full"}
                            keyName="Remission Status Full"
                            value={
                                mentalSessionSummaryReportObject.summary_mdd["17b_mdd_remission_full"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                        />

                        <li style={{ fontWeight: "bold" }}>
                            Specific Features:
                        </li>
                        <SubFormatArrayComponent
                            subIndex={"18_mdd_distress"}
                            keyName="Anxious Distress"
                            value={
                                mentalSessionSummaryReportObject.summary_mdd["18_mdd_distress"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                        />
                        <SubFormatArrayComponent
                            subIndex={"19_mdd_mixed"}
                            keyName="Mixed Features"
                            value={
                                mentalSessionSummaryReportObject.summary_mdd["19_mdd_mixed"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                        />
                        <SubFormatArrayComponent
                            subIndex={"20_mdd_melancholic"}
                            keyName="Melancholic Features"
                            value={
                                mentalSessionSummaryReportObject.summary_mdd["20_mdd_melancholic"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                        />
                        <SubFormatArrayComponent
                            subIndex={"21_mdd_atypical"}
                            keyName="Atypical Features"
                            value={
                                mentalSessionSummaryReportObject.summary_mdd["21_mdd_atypical"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                        />
                        <SubFormatArrayComponent
                            subIndex={"22_mdd_psychotic"}
                            keyName="Psychotic Features"
                            value={
                                mentalSessionSummaryReportObject.summary_mdd["22_mdd_psychotic"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                        />
                        <SubFormatArrayComponent
                            subIndex={"23_mdd_catatonia"}
                            keyName="Catatonia"
                            value={
                                mentalSessionSummaryReportObject.summary_mdd["23_mdd_catatonia"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                        />
                        <SubFormatArrayComponent
                            subIndex={"24_mdd_peripartum"}
                            keyName="Peripartum Onset"
                            value={
                                mentalSessionSummaryReportObject.summary_mdd["24_mdd_peripartum"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                        />
                        <SubFormatArrayComponent
                            subIndex={"25_mdd_seasonal"}
                            keyName="Seasonal Pattern"
                            value={
                                mentalSessionSummaryReportObject.summary_mdd["25_mdd_seasonal"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_mdd')}
                        />
                        <FormatArray
                            subIndex={"diagnostic_frameworks"}
                            keyName="Diagnostic Frameworks"
                            value={"ICD-10 & DSM-5 Depressive disorders"}
                        />
                    </ul>
                </>
            )}

            {/* GAD */}
            {dignosisPrincipalList.includes("GAD") && (
                <>
                    <h3 style={{ marginLeft: "20px" }}>
                        Generalized Anxiety Disorder
                    </h3>
                    <ul>
                        <li key="Principal Clinical Findings">
                            <strong>Principal Clinical Findings:</strong>{" "}
                            {principalClinicalFindingsData.length &&
                                principalClinicalFindingsData.find(
                                    (item: { gad: any }) => item.gad
                                )?.gad?.diagnosis ? (
                                principalClinicalFindingsData
                                    .find((item: { gad: any }) => item.gad)
                                    ?.gad?.diagnosis.map(
                                        (
                                            item: { disorder: string; severity: string },
                                            index: number
                                        ) => (
                                            <React.Fragment key={index}>
                                                {index === 0 ? (
                                                    isEdit ? (
                                                        <TextField
                                                            key={index}
                                                            variant="standard"
                                                            fullWidth
                                                            value={item.disorder}
                                                            onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'gad', 'disorder')}
                                                            style={{ display: "block" }}
                                                        />
                                                    ) : item?.disorder?.length ? (
                                                        removeLastCommaAndWord(item.disorder)
                                                    ) : (
                                                        "N-A"
                                                    )
                                                ) : (
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            paddingLeft: "2em",
                                                        }}
                                                    >
                                                        {isEdit ? (
                                                            <TextField
                                                                key={index}
                                                                variant="standard"
                                                                fullWidth
                                                                value={item.disorder}
                                                                onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'gad', 'disorder')}
                                                                style={{ display: "block" }}
                                                            />
                                                        ) : item?.disorder?.length ? (
                                                            removeLastCommaAndWord(item.disorder)
                                                        ) : (
                                                            " "
                                                        )}
                                                    </span>
                                                )}
                                            </React.Fragment>
                                        )
                                    )
                            ) : (
                                " "
                            )}
                        </li>
                        <li key="ICD-10 CM code">
                            <strong>ICD-10 CM code:</strong>{" "}
                            {principalClinicalFindingsData.length &&
                                principalClinicalFindingsData.find(
                                    (item: { gad: any }) => item.gad
                                )?.gad?.diagnosis ? (
                                principalClinicalFindingsData
                                    .find((item: { gad: any }) => item.gad)
                                    ?.gad?.diagnosis.map(
                                        (
                                            item: { code: string; },
                                            index: number
                                        ) => (
                                            <React.Fragment key={index}>
                                                {index === 0 ? (
                                                    isEdit ? (
                                                        <TextField
                                                            key={index}
                                                            variant="standard"
                                                            fullWidth
                                                            value={item.code}
                                                            onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'gad', 'code')}
                                                            style={{ display: "block" }}
                                                        />
                                                    ) : item?.code?.length ? (
                                                        removeLastCommaAndWord(item.code)
                                                    ) : (
                                                        "N-A"
                                                    )
                                                ) : (
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            paddingLeft: "2em",
                                                        }}
                                                    >
                                                        {isEdit ? (
                                                            <TextField
                                                                key={index}
                                                                variant="standard"
                                                                fullWidth
                                                                value={item.code}
                                                                onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'gad', 'code')}
                                                                style={{ display: "block" }}
                                                            />
                                                        ) : item?.code?.length ? (
                                                            removeLastCommaAndWord(item.code)
                                                        ) : (
                                                            " "
                                                        )}
                                                    </span>
                                                )}
                                            </React.Fragment>
                                        )
                                    )
                            ) : (
                                " "
                            )}
                        </li>
                        <li key="serverity">
                            <strong>serverity:</strong> <br></br>
                            {principalClinicalFindingsData.length &&
                                principalClinicalFindingsData.find(
                                    (item: { gad: any }) => item.gad
                                )?.gad?.diagnosis ? (
                                principalClinicalFindingsData
                                    .find((item: { gad: any }) => item.gad)
                                    ?.gad?.diagnosis.map(
                                        (
                                            item: { severity: string; },
                                            index: number
                                        ) => (
                                            <React.Fragment key={index}>
                                                {index === 0 ? (
                                                    isEdit ? (
                                                        <TextField
                                                            key={index}
                                                            variant="standard"
                                                            fullWidth
                                                            value={item.severity}
                                                            onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'gad', 'severity')}
                                                            style={{ display: "block" }}
                                                        />
                                                    ) : item?.severity?.length ? (
                                                        removeLastCommaAndWord(item.severity)
                                                    ) : (
                                                        "N-A"
                                                    )
                                                ) : (
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            paddingLeft: "2em",
                                                        }}
                                                    >
                                                        {isEdit ? (
                                                            <TextField
                                                                key={index}
                                                                variant="standard"
                                                                fullWidth
                                                                value={item.severity}
                                                                onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'gad', 'severity')}
                                                                style={{ display: "block" }}
                                                            />
                                                        ) : item?.severity?.length ? (
                                                            removeLastCommaAndWord(item.severity)
                                                        ) : (
                                                            " "
                                                        )}
                                                    </span>
                                                )}
                                            </React.Fragment>
                                        )
                                    )
                            ) : (
                                " "
                            )}

                        </li>

                        <FormatArray
                            subIndex={"diagnostic_frameworks"}
                            keyName="Diagnostic Frameworks"
                            value={"ICD-10 & DSM-5 Anxiety disorders"}
                        />
                    </ul>
                </>
            )}

            {/* SUD */}
            {dignosisPrincipalList.includes("SUD") && (
                <>
                    <h3 style={{ marginLeft: "20px" }}>
                        Substance Use Disorder
                    </h3>
                    <ul>
                        <li key="Principal Clinical Findings">
                            <strong>Principal Clinical Findings:</strong>{" "}
                            {principalClinicalFindingsData.length &&
                                principalClinicalFindingsData.find(
                                    (item: { sud: any }) => item.sud
                                )?.sud?.diagnosis ? (
                                principalClinicalFindingsData
                                    .find((item: { sud: any }) => item.sud)
                                    ?.sud?.diagnosis.map(
                                        (
                                            item: { disorder: string; severity: string },
                                            index: number
                                        ) => (
                                            <React.Fragment key={index}>
                                                {index === 0 ? (
                                                    isEdit ? (
                                                        <TextField
                                                            key={index}
                                                            variant="standard"
                                                            fullWidth
                                                            value={item.disorder}
                                                            onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'sud', 'disorder')}
                                                            style={{ display: "block" }}
                                                        />
                                                    ) : item?.disorder?.length ? (
                                                        removeLastCommaAndWord(item.disorder)
                                                    ) : (
                                                        "N-A"
                                                    )
                                                ) : (
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            paddingLeft: "2em",
                                                        }}
                                                    >
                                                        {isEdit ? (
                                                            <TextField
                                                                key={index}
                                                                variant="standard"
                                                                fullWidth
                                                                value={item.disorder}
                                                                onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'sud', 'disorder')}
                                                                style={{ display: "block" }}
                                                            />
                                                        ) : item?.disorder?.length ? (
                                                            removeLastCommaAndWord(item.disorder)
                                                        ) : (
                                                            " "
                                                        )}
                                                    </span>
                                                )}
                                            </React.Fragment>
                                        )
                                    )
                            ) : (
                                " "
                            )}
                        </li>
                        <li key="ICD-10 CM code">
                            <strong>ICD-10 CM code:</strong>{" "}
                            {principalClinicalFindingsData.length &&
                                principalClinicalFindingsData.find(
                                    (item: { sud: any }) => item.sud
                                )?.sud?.diagnosis ? (
                                principalClinicalFindingsData
                                    .find((item: { sud: any }) => item.sud)
                                    ?.sud?.diagnosis.map(
                                        (
                                            item: { code: string; },
                                            index: number
                                        ) => (
                                            <React.Fragment key={index}>
                                                {index === 0 ? (
                                                    isEdit ? (
                                                        <TextField
                                                            key={index}
                                                            variant="standard"
                                                            fullWidth
                                                            value={item.code}
                                                            onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'sud', 'code')}
                                                            style={{ display: "block" }}
                                                        />
                                                    ) : item?.code?.length ? (
                                                        removeLastCommaAndWord(item.code)
                                                    ) : (
                                                        "N-A"
                                                    )
                                                ) : (
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            paddingLeft: "2em",
                                                        }}
                                                    >
                                                        {isEdit ? (
                                                            <TextField
                                                                key={index}
                                                                variant="standard"
                                                                fullWidth
                                                                value={item.code}
                                                                onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'sud', 'code')}
                                                                style={{ display: "block" }}
                                                            />
                                                        ) : item?.code?.length ? (
                                                            removeLastCommaAndWord(item.code)
                                                        ) : (
                                                            " "
                                                        )}
                                                    </span>
                                                )}
                                            </React.Fragment>
                                        )
                                    )
                            ) : (
                                " "
                            )}
                        </li>


                        <FormatArrayComponent
                            subIndex={"main_substance"}
                            keyName="Main Substance"
                            value={
                                mentalSessionSummaryReportObject.summary_sud["main_substance"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                        />

                        <FormatArrayComponent
                            subIndex={"secondary_substances"}
                            keyName="Other Substances"
                            value={
                                mentalSessionSummaryReportObject.summary_sud["secondary_substances"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_sud')}
                        />
                        <li key="serverity">
                            <strong>serverity:</strong> <br></br>
                            {principalClinicalFindingsData.length &&
                                principalClinicalFindingsData.find(
                                    (item: { sud: any }) => item.sud
                                )?.sud?.diagnosis ? (
                                principalClinicalFindingsData
                                    .find((item: { sud: any }) => item.sud)
                                    ?.sud?.diagnosis.map(
                                        (
                                            item: { severity: string; },
                                            index: number
                                        ) => (
                                            <React.Fragment key={index}>
                                                {index === 0 ? (
                                                    isEdit ? (
                                                        <TextField
                                                            key={index}
                                                            variant="standard"
                                                            fullWidth
                                                            value={item.severity}
                                                            onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'sud', 'severity')}
                                                            style={{ display: "block" }}
                                                        />
                                                    ) : item?.severity?.length ? (
                                                        removeLastCommaAndWord(item.severity)
                                                    ) : (
                                                        "N-A"
                                                    )
                                                ) : (
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            paddingLeft: "2em",
                                                        }}
                                                    >
                                                        {isEdit ? (
                                                            <TextField
                                                                key={index}
                                                                variant="standard"
                                                                fullWidth
                                                                value={item.severity}
                                                                onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'sud', 'severity')}
                                                                style={{ display: "block" }}
                                                            />
                                                        ) : item?.severity?.length ? (
                                                            removeLastCommaAndWord(item.severity)
                                                        ) : (
                                                            " "
                                                        )}
                                                    </span>
                                                )}
                                            </React.Fragment>
                                        )
                                    )
                            ) : (
                                " "
                            )}

                        </li>
                        <FormatArray
                            subIndex={"substance"}
                            keyName="Frameworks"
                            value="ICD-10 & DSM-5 substance use disorder."
                        />
                    </ul>
                </>
            )}

            {/* PTSD */}
            {dignosisPrincipalList.includes("PTSD") && (
                <>
                    <h3 style={{ marginLeft: "20px" }}>
                        Post-Traumatic Stress Disorder (PTSD)
                    </h3>
                    <ul>
                        <li key="Principal Clinical Findings">
                            <strong>Principal Clinical Findings:</strong>{" "}
                            {principalClinicalFindingsData.length &&
                                principalClinicalFindingsData.find(
                                    (item: { ptsd: any }) => item.ptsd
                                )?.ptsd?.diagnosis ? (
                                principalClinicalFindingsData
                                    .find((item: { ptsd: any }) => item.ptsd)
                                    ?.ptsd?.diagnosis.map(
                                        (
                                            item: { disorder: string; severity: string },
                                            index: number
                                        ) => (
                                            <React.Fragment key={index}>
                                                {index === 0 ? (
                                                    isEdit ? (
                                                        <TextField
                                                            key={index}
                                                            variant="standard"
                                                            fullWidth
                                                            value={item.disorder}
                                                            onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'ptsd', 'disorder')}
                                                            style={{ display: "block" }}
                                                        />
                                                    ) : item?.disorder?.length ? (
                                                        removeLastCommaAndWord(item.disorder)
                                                    ) : (
                                                        "N-A"
                                                    )
                                                ) : (
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            paddingLeft: "2em",
                                                        }}
                                                    >
                                                        {isEdit ? (
                                                            <TextField
                                                                key={index}
                                                                variant="standard"
                                                                fullWidth
                                                                value={item.disorder}
                                                                onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'ptsd', 'disorder')}
                                                                style={{ display: "block" }}
                                                            />
                                                        ) : item?.disorder?.length ? (
                                                            removeLastCommaAndWord(item.disorder)
                                                        ) : (
                                                            " "
                                                        )}
                                                    </span>
                                                )}
                                            </React.Fragment>
                                        )
                                    )
                            ) : (
                                " "
                            )}
                        </li>
                        <li key="ICD-10 CM code">
                            <strong>ICD-10 CM code:</strong>{" "}
                            {principalClinicalFindingsData.length &&
                                principalClinicalFindingsData.find(
                                    (item: { ptsd: any }) => item.ptsd
                                )?.ptsd?.diagnosis ? (
                                principalClinicalFindingsData
                                    .find((item: { ptsd: any }) => item.ptsd)
                                    ?.ptsd?.diagnosis.map(
                                        (
                                            item: { code: string; },
                                            index: number
                                        ) => (
                                            <React.Fragment key={index}>
                                                {index === 0 ? (
                                                    isEdit ? (
                                                        <TextField
                                                            key={index}
                                                            variant="standard"
                                                            fullWidth
                                                            value={item.code}
                                                            onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'ptsd', 'code')}
                                                            style={{ display: "block" }}
                                                        />
                                                    ) : item?.code?.length ? (
                                                        removeLastCommaAndWord(item.code)
                                                    ) : (
                                                        "N-A"
                                                    )
                                                ) : (
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            paddingLeft: "2em",
                                                        }}
                                                    >
                                                        {isEdit ? (
                                                            <TextField
                                                                key={index}
                                                                variant="standard"
                                                                fullWidth
                                                                value={item.code}
                                                                onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'ptsd', 'code')}
                                                                style={{ display: "block" }}
                                                            />
                                                        ) : item?.code?.length ? (
                                                            removeLastCommaAndWord(item.code)
                                                        ) : (
                                                            " "
                                                        )}
                                                    </span>
                                                )}
                                            </React.Fragment>
                                        )
                                    )
                            ) : (
                                " "
                            )}
                        </li>
                        <FormatArray
                            subIndex={"Subtype(s)"}
                            keyName="Subtype(s)"
                            value=""
                        />

                        <SubFormatArrayComponent
                            subIndex={"9_a_ptsd_dissociation_depersonalization"}
                            keyName="Depersonalization"
                            value={
                                mentalSessionSummaryReportObject.summary_ptsd["9_a_ptsd_dissociation_depersonalization"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                        />
                        <SubFormatArrayComponent
                            subIndex={"9_b_ptsd_dissociation_derealization"}
                            keyName="Derealization"
                            value={
                                mentalSessionSummaryReportObject.summary_ptsd["9_b_ptsd_dissociation_derealization"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                        />
                        <SubFormatArrayComponent
                            subIndex={"10_ptsd_delayed_expression"}
                            keyName="Delayed Expression"
                            value={
                                mentalSessionSummaryReportObject.summary_ptsd["10_ptsd_delayed_expression"]
                            }
                            isEdited={isEdit}
                            handleInputChange={(key, value) => handleInputChange(key, value, 'summary_ptsd')}
                        />

                        <FormatArray
                            subIndex={"substance"}
                            keyName="Frameworks"
                            value="ICD-10 & DSM-5 substance use disorder."
                        />
                    </ul>
                </>
            )}

            {/* Sleep Disorder */}
            {(dignosisPrincipalList.includes("INSOMNIA") ||
                dignosisPrincipalList.includes("HYPERSOMNOLENCE") ||
                dignosisPrincipalList.includes("CRSWD")) && (
                    <>
                        <h3 style={{ marginLeft: "20px" }}>
                            Sleep Disorder
                        </h3>
                        <ul>
                            <li key="Principal Clinical Findings">
                                <strong>Principal Clinical Findings:</strong>{" "}
                                {principalClinicalFindingsData.length &&
                                    principalClinicalFindingsData.find(
                                        (item: { sleep: any }) => item.sleep
                                    )?.sleep?.diagnosis ? (
                                    principalClinicalFindingsData
                                        .find((item: { sleep: any }) => item.sleep)
                                        ?.sleep?.diagnosis.map(
                                            (
                                                item: { disorder: string; severity: string },
                                                index: number
                                            ) => (
                                                <React.Fragment key={index}>
                                                    {index === 0 ? (
                                                        isEdit ? (
                                                            <TextField
                                                                key={index}
                                                                variant="standard"
                                                                fullWidth
                                                                value={item.disorder}
                                                                onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'sleep', 'disorder')}
                                                                style={{ display: "block" }}
                                                            />
                                                        ) : item?.disorder?.length ? (
                                                            removeLastCommaAndWord(item.disorder)
                                                        ) : (
                                                            "N-A"
                                                        )
                                                    ) : (
                                                        <span
                                                            style={{
                                                                display: "block",
                                                                paddingLeft: "2em",
                                                            }}
                                                        >
                                                            {isEdit ? (
                                                                <TextField
                                                                    key={index}
                                                                    variant="standard"
                                                                    fullWidth
                                                                    value={item.disorder}
                                                                    onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'sleep', 'disorder')}
                                                                    style={{ display: "block" }}
                                                                />
                                                            ) : item?.disorder?.length ? (
                                                                removeLastCommaAndWord(item.disorder)
                                                            ) : (
                                                                " "
                                                            )}
                                                        </span>
                                                    )}
                                                </React.Fragment>
                                            )
                                        )
                                ) : (
                                    " "
                                )}
                            </li>
                            <li key="ICD-10 CM code">
                                <strong>ICD-10 CM code:</strong>{" "}
                                {principalClinicalFindingsData.length &&
                                    principalClinicalFindingsData.find(
                                        (item: { sleep: any }) => item.sleep
                                    )?.sleep?.diagnosis ? (
                                    principalClinicalFindingsData
                                        .find((item: { sleep: any }) => item.sleep)
                                        ?.sleep?.diagnosis.map(
                                            (
                                                item: { code: string; },
                                                index: number
                                            ) => (
                                                <React.Fragment key={index}>
                                                    {index === 0 ? (
                                                        isEdit ? (
                                                            <TextField
                                                                key={index}
                                                                variant="standard"
                                                                fullWidth
                                                                value={item.code}
                                                                onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'sleep', 'code')}
                                                                style={{ display: "block" }}
                                                            />
                                                        ) : item?.code?.length ? (
                                                            removeLastCommaAndWord(item.code)
                                                        ) : (
                                                            "N-A"
                                                        )
                                                    ) : (
                                                        <span
                                                            style={{
                                                                display: "block",
                                                                paddingLeft: "2em",
                                                            }}
                                                        >
                                                            {isEdit ? (
                                                                <TextField
                                                                    key={index}
                                                                    variant="standard"
                                                                    fullWidth
                                                                    value={item.code}
                                                                    onChange={(e) => handleprincipalClinicalChange(index, e.target.value, 'sleep', 'code')}
                                                                    style={{ display: "block" }}
                                                                />
                                                            ) : item?.code?.length ? (
                                                                removeLastCommaAndWord(item.code)
                                                            ) : (
                                                                " "
                                                            )}
                                                        </span>
                                                    )}
                                                </React.Fragment>
                                            )
                                        )
                                ) : (
                                    " "
                                )}
                            </li>
                            <FormatArray
                                subIndex={"Frameworks"}
                                keyName="Frameworks"
                                value="DSM-5"
                            />
                        </ul>
                    </>
                )}

            <span
                style={{
                    ...sessionReportTitle,
                    display: dignosisPrincipalList.length
                        ? "block"
                        : "none",
                }}
            >
                References for Clinical Findings
            </span>

            <span
                style={{
                    ...dignosisReportSubtitle,
                    display: dignosisPrincipalList.length
                        ? "block"
                        : "none",
                    backgroundColor: "#faf7dc",
                    marginTop: "10px",
                }}
            >
                References for Principal Clinical Findings
            </span>
            {/* MDD */}
            {dignosisPrincipalList.includes("MDD") && (
                <React.Fragment >
                    {MDD()}
                </React.Fragment>
            )}

            {/* GAD */}
            {dignosisPrincipalList.includes("GAD") && (
                <React.Fragment >
                    {GAD()}
                </React.Fragment>
            )}

            {/* SUD */}
            {dignosisPrincipalList.includes("SUD") && (
                <React.Fragment >
                    {SUD()}
                </React.Fragment>
            )}

            {/* INSOMNIA */}
            {dignosisPrincipalList.includes("INSOMNIA") && (
                <React.Fragment >
                    {INSOMNIA()}
                </React.Fragment>
            )}

            {/* HYPERSOMNOLENCE */}
            {dignosisPrincipalList.includes(
                "HYPERSOMNOLENCE"
            ) && (
                    <React.Fragment >
                        {HYPERSOMNOLENCE()}
                    </React.Fragment>
                )}

            {/* Circadian Rhythm Sleep-Wake Disorder */}
            {dignosisPrincipalList.includes("CRSWD") && (

                <React.Fragment >
                    {CRSWD()}
                </React.Fragment>
            )}

            {/* PTSD */}
            {dignosisPrincipalList.includes("PTSD") && (
                <React.Fragment >
                    {PTSD()}
                </React.Fragment>
            )}

            <span
                style={{
                    ...sessionReportSummaryReportTitle,
                    display: dignosisSubthresholdList.length
                        ? "block"
                        : "none",
                }}
            >
                References for Subthreshold Clinical Findings
            </span>

            {/* MDD */}
            {dignosisSubthresholdList.includes("MDD") && (
                <React.Fragment >
                    {MDD()}
                </React.Fragment>
            )}

            {/* GAD */}
            {dignosisSubthresholdList.includes("GAD") && (
                <React.Fragment >
                    {GAD()}
                </React.Fragment>
            )}

            {/* SUD */}
            {dignosisSubthresholdList.includes("SUD") && (
                <React.Fragment >
                    {SUD()}
                </React.Fragment>
            )}

            {/* INSOMNIA */}
            {dignosisSubthresholdList.includes("INSOMNIA") && (
                <React.Fragment >
                    {INSOMNIA()}
                </React.Fragment>
            )}

            {/* HYPERSOMNOLENCE */}
            {dignosisSubthresholdList.includes(
                "HYPERSOMNOLENCE"
            ) && (
                    <React.Fragment >
                        {HYPERSOMNOLENCE()}
                    </React.Fragment>
                )}

            {/*  Circadian Rhythm Sleep-Wake Disorder  */}
            {dignosisSubthresholdList.includes("CRSWD") && (
                <React.Fragment >
                    {CRSWD()}
                </React.Fragment>
            )}

            {/* PTSD */}
            {dignosisSubthresholdList.includes("PTSD") && (
                <React.Fragment >
                    {PTSD()}
                </React.Fragment>
            )}
        </>
    )
}

export default AssessmentRecommendation;